import Lenis from "lenis";

let lenisInstance: Lenis | null = null;

export function setLenisInstance(instance: Lenis | null) {
  lenisInstance = instance;
}

export function getLenisInstance() {
  return lenisInstance;
}

export function scrollToTarget(target: string | HTMLElement, offset = 0) {
  if (lenisInstance) {
    lenisInstance.scrollTo(target, { offset });
    return;
  }

  const element =
    typeof target === "string" ? document.querySelector<HTMLElement>(target) : target;

  if (!element) {
    return;
  }

  window.scrollTo({
    top: Math.max(window.scrollY + element.getBoundingClientRect().top + offset, 0),
    behavior: "smooth"
  });
}
